import './AvatarGroup.css';
export var additionalAvatarWrapperCSS = '_1b4iymp0-2-0-1';
export var avatarGroupItemWrapperCSS = '_1b4iymp1-2-0-1';